<template>
    <div v-if="hasFilters" class="flex flex-wrap items-center gap-12">
        <action-button
            icon="cancel"
            v-if="getDateFrom != '' || getDateTo != ''"
            @click="removeDate()"
        >
            <span class="text-primary-80 mr-4 capitalize">{{ $t('general.date.title') }}:</span>
            <span>
                <span v-if="getDateFrom != ''" :class="getDateTo ? 'mr-4' : ''">
                    {{ $t('applications.filters.date_from') }} {{ getDateFrom }}
                </span>
                <span v-if="getDateTo != ''">
                    {{ $t('applications.filters.date_to') }} {{ getDateTo }}
                </span>
            </span>
        </action-button>
        <action-button
            v-if="getStatus != ''"
            icon="cancel"
            @click="removeStatuses()"
        >
            <span class="text-primary-80 mr-4">{{ $t('applications.status') }}: </span>
            <span>
                {{ getStatus }}
            </span>
        </action-button>
        <action-button
            v-for="item in items"
            :key="item.id"
            icon="cancel"
            @click="removeCheckbox(item)"
        >
            <span v-if="item.icon">
                <svg-icon :type="item.icon" class="w-18 h-18" :class="'fill-' + item.color" />
            </span>
            <span>
                {{ item.label }}
            </span>
        </action-button>
        <action-button
            class="!bg-primary-20 hover:!bg-primary-60 !text-primary-80 hover:!text-white"
            icon="cancel"
            @click="removeAllFilters()"
        >
            {{ $t('applications.filters.clear_filters') }}
        </action-button>
    </div>
</template>

<script>
import SvgIcon from '../ui/SvgIcon.vue';
import Tag from '../../models/Tag';
import moment from 'moment';
import {mapState} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import InterviewStatus from "../../models/InterviewStatus";
import User from "../../models/User";
import JobFunction from "../../models/JobFunction";
import ActionButton from "../ui/ActionButton.vue";

export default {
    components: {
        ActionButton,
        'svg-icon': SvgIcon,
    },
    props: {
        filter: Object,
        filterValues: Object,
    },
    data: function () {
        return {
            classes: 'mr-12 px-14 py-8 mb-8 last:mr-0 rounded-4 bg-white border border-primary-20 flex items-center z-10 hover:bg-primary-5 trans-ease',
        };
    },
    computed: {
        ...mapState(useMainStore, ['dateFormat', 'locale']),
        hasFilters() {
            return !!(this.getDateFrom
                || this.getDateTo
                || this.getStatus
                || this.items.length);
        },
        getDateFrom() {
            if (this.filterValues.date_from === '') {
                return '';
            }

            return moment(this.filterValues.date_from).locale(this.locale).format(this.dateFormat);
        },
        getDateTo() {
            if (this.filterValues.date_to === '') {
                return '';
            }

            return moment(this.filterValues.date_to).locale(this.locale).format(this.dateFormat);
        },
        getStatus() {
            let statuses = [];

            if (this.filterValues.new) {
                statuses.push(this.$t('general.new'));
            }

            if (this.filterValues.hired) {
                statuses.push(this.$t('analytics.hired'));
            }

            if (this.filterValues.stages.length) {
                statuses.push(...this.filterValues.stages.map(stage => stage.split(':')[0]));
            }

            return statuses.length
                ? statuses[0] + (statuses.length > 1 ? ` ${this.$t('general.and').toLowerCase()} ${statuses.length - 1} ${this.$t('general.other').toLowerCase()} ` : '')
                : '';
        },
        items() {
            let items = [],
                x;

            if (this.filterValues.jobfunctions.length) {
                for (x of this.filterValues.jobfunctions) {
                    x = useRepo(JobFunction).find(x);

                    if (x !== null) {
                        items.push({
                            property: 'jobfunctions',
                            id: x.id,
                            label: x.title[this.locale],
                        });
                    }
                }
            }

            if (this.filterValues.statuses?.length) {
                for (x of this.filterValues.statuses) {
                    x = useRepo(InterviewStatus).find(x);

                    if (x !== null) {
                        items.push({
                            property: 'statuses',
                            id: x.id,
                            label: x.name,
                            icon: x.icon,
                            color: x.color,
                        });
                    }
                }
            }

            if (this.filterValues.tags?.length) {
                for (x of this.filterValues.tags) {
                    x = useRepo(Tag).find(x);

                    if (x !== null) {
                        items.push({
                            property: 'tags',
                            id: x.id,
                            label: x.title,
                        });
                    }
                }
            }

            if (this.filterValues.users?.length) {
                for (x of this.filterValues.users) {
                    x = useRepo(User).find(x);

                    if (x !== null) {
                        items.push({
                            property: 'users',
                            id: x.id,
                            label: x.name,
                        });
                    }
                }
            }

            return items;
        },
    },
    methods: {
        removeCheckbox(checkbox) {
            if (typeof this.filter[checkbox.property] == 'undefined') {
                return;
            }

            let chk = [],
                x
            ;

            for (x of this.filter[checkbox.property]) {
                if (x != checkbox.id) {
                    chk.push(x);
                }
            }

            this.filter[checkbox.property] = chk;

            this.$emit('update');
        },
        removeDate() {
            this.filter.date_from = '';
            this.filter.date_to = '';

            this.$emit('update');
        },
        removeStatuses() {
            this.filter.new = false;
            this.filter.hired = false;
            this.filter.stages = [];

            this.$emit('update');
        },
        removeAllFilters() {
            this.filter.new = false;
            this.filter.hired = false;
            this.filter.date_from = '';
            this.filter.date_to = '';
            this.filter.users = [];
            this.filter.tags = [];
            this.filter.statuses = [];
            this.filter.stages = [];
            this.filter.jobfunctions = [];

            this.$emit('update');
        },
    },
};
</script>
